import React, { createContext, useContext, useState } from "react";

const DynamicHeaderContext = createContext({
  setHeader: (header: React.ReactNode) => {},
  header: null as React.ReactNode | null,
});

export const useDynamicHeader = () => useContext(DynamicHeaderContext);

export const DynamicHeaderProvider = ({ children }: { children: React.ReactNode }) => {
  const [header, setHeader] = useState<React.ReactNode>(null);

  return (
    <DynamicHeaderContext.Provider value={{ setHeader, header }}>
      {children}
    </DynamicHeaderContext.Provider>
  );
}; 